import {
  put,
  call,
  select,
  all
} from 'redux-saga/effects';
import { showNotification } from '../../notifications/actions';
import { parseApiError } from '../../util/api';
import OrgAdminAPI from '../orgAdmin/OrgAdminAPI';
import { getOrgsObj, hasFetchedOrgs } from '../orgAdmin/reducer';
import {
  fetchUltrasoundScansFail,
  fetchUltrasoundScansSuccess
} from './actions';
import UltrasoundAPI from './UltrasoundAPI';

export const buildOrgsObject = orgsArray => {
  const obj = {};
  orgsArray.forEach(org => {
    obj[org.id] = org;
  });
  return obj;
};

export const addFarmName = (sessionsArray, orgsObj) => {
  return sessionsArray.map(session => {
    if (orgsObj[session.orgId] && orgsObj[session.orgId].name) {
      return { ...session, farm: orgsObj[session.orgId].name };
    }
    return { ...session };
  });
};

export function *fetchUltrasoundScans () {
  try {
    const haveFetchedOrgs = yield select(hasFetchedOrgs);
    let orgsObj = {};
    let scanSessions = null;
    if (haveFetchedOrgs) {
      orgsObj = yield select(getOrgsObj);
      const scansResponse = yield call(UltrasoundAPI.fetchUltrasoundScans);
      scanSessions = scansResponse.data.scanSessions;
    } else {
      const [ scansResponse, orgsReponse ] = yield all([
        call(UltrasoundAPI.fetchUltrasoundScans),
        call(OrgAdminAPI.fetchOrgs)
      ]);
      orgsObj = buildOrgsObject(orgsReponse.data.orgs);
      scanSessions = scansResponse.data.scanSessions;
    }
    scanSessions = addFarmName(scanSessions, orgsObj);
    yield put(fetchUltrasoundScansSuccess(scanSessions));
  } catch (error) {
    const msg = parseApiError(error);
    yield put(fetchUltrasoundScansFail(msg));
    yield put(showNotification(
      'Failed to load Ultrasound Scanning Sessions', msg, 'error', 10
    ));
  }
}
